import styled, { css } from 'styled-components';
import { colors } from '../../../../styles/colors';
import { headingLevel, type HeadingLevel } from '../../../../styles/onboardingUiTokens';

const headingCss = (level: HeadingLevel) => {
  const h = headingLevel[level];
  return css`
    margin: 0;
    color: ${colors.dark};
    font-style: normal;
    font-family: ${h.fontFamily};
    font-weight: ${h.fontWeight};
    letter-spacing: ${h.letterSpacing};
    font-size: ${h.fontSize};
    line-height: ${h.lineHeight};
  `;
};

/** Level 1 — Lora, bold; max ~28px / 34px line (intrinsic `clamp`). */
export const H1 = styled.h1`
  ${headingCss(1)}
`;

/** Level 2 — Lora, medium; max ~24px / 34px line. */
export const H2 = styled.h2`
  ${headingCss(2)}
`;

/** Level 3 — Ubuntu, medium; max ~18px / 24px line. */
export const H3 = styled.h3`
  ${headingCss(3)}
`;

/** Level 4 — Ubuntu, medium; max ~16px / 26px line. */
export const H4 = styled.h4`
  ${headingCss(4)}
`;

/** Level 5 — Ubuntu, regular; max ~16px / 26px line. */
export const H5 = styled.h5`
  ${headingCss(5)}
`;

/** Level 6 — Ubuntu, semibold; max ~14px / 20px line (kit extension beyond legacy `stringStyles`). */
export const H6 = styled.h6`
  ${headingCss(6)}
`;
